module.exports = __webpack_public_path__ + "img/quiz-star.18a035d3.svg";